// components/AuthHandler.tsx
import { useEffect } from 'react';
import { saveUser, getUser } from 'CometChat/utils/userToken.utils';
import { User } from 'CometChat/types/user.types';

const HARDCODED_USER: User = {
  uid: 'sendo-trainer-main',
  authToken: 'sendo-trainer-main_164736459886d548f4a4e63541cb5091c7d46ee9',
  displayName: 'Sendo Trainer',
  role: 'trainer',
  pvo: true,
  pcl: true,
  jwt: '',
};

interface AuthHandlerProps {
  children: React.ReactNode;
}

function AuthHandler({ children }: AuthHandlerProps): JSX.Element {
  useEffect(() => {
    const existingUser = getUser();
    if (!existingUser || existingUser.uid !== HARDCODED_USER.uid) {
      saveUser(HARDCODED_USER);
    }
  }, []);

  return <>{children}</>;
}

export default AuthHandler;